import axios from "axios";
import {
    IP
} from "../index";

/* 开柜记录 */

// 查询
export async function selectOpenBox() {
    var resp = await axios.post(`${IP}/admin/openBox/select`, {

    });
    return resp.data;
}
// 删除
export async function deleteOpenBox(id) {
    var resp = await axios.post(`${IP}/admin/openBox/delete`, {
        id
    });
    return resp.data;
}